import { useState, useContext } from 'react';
import { AuthContext } from '../context/authContext';
import VersionHistory from '../components/VersionHistory';

const API = '/api';

export default function VersionHistoryPage() {
  const { token, role } = useContext(AuthContext);
  const [inputValue, setInputValue] = useState('');
  const [obraInfo, setObraInfo] = useState(null);
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  if (role !== 'admin') {
    return (
      <div className="p-8 text-center text-gray-500">
        Acceso denegado. Solo administradores.
      </div>
    );
  }

  const buscarObra = async () => {
    const val = inputValue.trim();
    if (!val) return;
    setCargando(true);
    setError('');
    setObraInfo(null);
    try {
      const res = await fetch(`${API}/obras/lookup/${encodeURIComponent(val)}`, {
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      });
      if (!res.ok) {
        const d = await res.json();
        throw new Error(d.error || 'Obra no encontrada');
      }
      const d = await res.json();
      setObraInfo(d);
    } catch (e) {
      setError(e.message);
    }
    setCargando(false);
  };

  return (
    <div className="p-6 w-full max-w-full">
      <h1 className="text-xl font-bold text-gray-800 mb-4">
        Historial de Versiones
      </h1>

      <div className="flex gap-2 mb-6">
        <input
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && buscarObra()}
          placeholder="Ej: 116-014"
          className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm"
        />
        <button
          onClick={buscarObra}
          disabled={cargando || !inputValue.trim()}
          className="bg-blue-600 text-white px-4 py-2 rounded text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
        >
          {cargando ? 'Buscando...' : 'Buscar'}
        </button>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 mb-4">
          {error}
        </div>
      )}

      {obraInfo && (
        <div className="bg-white border border-gray-200 rounded-md p-4 mb-4">
          <p className="text-sm text-gray-600">
            <span className="font-semibold">Obra:</span>{' '}
            {obraInfo.cg_02_nombre_obra || '(sin nombre)'}
          </p>
          <p className="text-sm text-gray-600">
            <span className="font-semibold">ID:</span>{' '}
            {obraInfo.cg_01_id_partido_obra}
            {' — '}
            <span className="font-semibold">Versión actual:</span>{' '}
            {obraInfo.version}
          </p>
        </div>
      )}

      {obraInfo && (
        <VersionHistory
          obraId={obraInfo.id}
          cg01IdPartidoObra={obraInfo.cg_01_id_partido_obra}
        />
      )}
    </div>
  );
}
